<template>
  <div class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-10-tablet is-9-desktop is-8-widescreen">
          <h1 class="title">Server Disk Usage</h1>

          <div v-if="isLoading" class="notification is-info">
            Loading disk usage...
          </div>

          <div v-if="error" class="notification is-danger">
            {{ error }}
          </div>

          <div v-if="diskUsage">
            <div class="box">
              <h2 class="subtitle">Server Root Directory</h2>

              <p><strong>Path:</strong> {{ diskUsage.server.path }}</p>
              <p><strong>Total:</strong> {{ diskUsage.server.total_gb }} GB</p>
              <p><strong>Used:</strong> {{ diskUsage.server.used_gb }} GB</p>
              <p><strong>Free:</strong> {{ diskUsage.server.free_gb }} GB ({{ readableSize(diskUsage.server.free_mb) }} MB)</p>

              <progress
                class="progress is-primary mt-4"
                :value="diskUsage.server.used_percent"
                max="100"
              >
                {{ diskUsage.server.used_percent }}%
              </progress>

              <p><strong>Used:</strong> {{ diskUsage.server.used_percent }}%</p>
              <p><strong>Free:</strong> {{ diskUsage.server.free_percent }}%</p>
            </div>

            <div class="box">
              <h2 class="subtitle">Media Directory</h2>
              <p class="has-text-grey mb-4">
                Contains stored server photos & generated PDF files.
              </p>

              <p><strong>Path:</strong> {{ diskUsage.media.path }}</p>

              <p>
                <strong>Directory Size:</strong>
                {{ diskUsage.media.size_mb }} MB
              </p>

              <div class="tags mt-4">
                <span class="tag is-info is-medium">
                  <span class="icon is-small mr-1">
                    <i class="fas fa-image"></i>
                  </span>

                  <span>
                    Photos: {{ diskUsage.media.photo_count }}
                  </span>
                </span>

                <span class="tag is-info is-medium">
                  <span class="icon is-small mr-1">
                    <i class="fas fa-file-pdf"></i>
                  </span>

                  <span>
                    PDFs: {{ diskUsage.media.pdf_count }}
                  </span>
                </span>
              </div>

              <div class="notification is-warning is-light mt-4">
                <p>
                  These files are generally safe to delete, you can click the
                  <strong>Refresh</strong> button on a Job Details page to
                  redownload the photos to the server & click
                  <strong>Print PDF</strong> to regenerate a Job Summary.
                </p>
              </div>

              <div class="buttons mt-5">
                <button
                  class="button is-danger"
                  @click="clearMediaDirectory"
                  :class="{ 'is-loading': isDeleting }"
                >
                  Delete All Media Files
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "DiskUsageView",

  data() {
    return {
      diskUsage: null,
      isLoading: false,
      isDeleting: false,
      error: null,
    }
  },

  mounted() {
    this.getDiskUsage()
  },

  methods: {
    async getDiskUsage() {
      this.isLoading = true
      this.error = null

      try {
        const response = await axios.get("/api/v1/disk-usage/")
        this.diskUsage = response.data
      } catch (error) {
        console.error(error)
        this.error = "Unable to load disk usage."
      } finally {
        this.isLoading = false
      }
    },
    readableSize(size) {
      return size.toLocaleString(undefined, {
        maximumFractionDigits: 0
      })
    },
    async clearMediaDirectory() {
      const confirmed = confirm(
        "Are you sure you want to permanently delete ALL server photos and PDFs?"
      )

      if (!confirmed) {
        return
      }

      this.isDeleting = true

      try {
        const response = await axios.delete(
          "/api/v1/clear-media-directory/"
        )

        alert(response.data.message)

        await this.getDiskUsage()

      } catch (error) {
        console.error(error)

        alert("Failed to clear media directory.")
      } finally {
        this.isDeleting = false
      }
    },
  },
}
</script>